import React, { FC, memo, useCallback, useMemo } from "react";

// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//styles
import { ComparisonHalfCardCta } from "./styles";

// types
import { TGCTAs } from "@swiggy-private/cart-types";
import { OneMembershipHandlers } from "@super-ui/components/cart-upsell-nudge/types";

// constants
import {
    CART_UPSELL_TEST_IDS,
    COMPARISON_HALFCARD_STORAGE_KEY,
    MAX_POLLING_COUNT,
} from "@super-ui/components/cart-upsell-nudge/constants";

// helpers
import { attachQueryParams } from "@super-ui/components/cart-upsell-nudge/helpers";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { usePolling } from "@super-ui/components/cart-upsell-nudge/hooks/usePolling";

interface ChangePlanCtaProps extends TGCTAs {
    isBlackPlan: boolean;
    handlers: OneMembershipHandlers;
    planId: number;
    planInCart?: string;
    onImpressionChangePlanCta: () => void;
    onClickChangePlanCta: () => void;
}

const ChangePlanCta: FC<ChangePlanCtaProps> = ({
    text,
    link,
    isBlackPlan,
    handlers,
    planId,
    planInCart = "",
    onClickChangePlanCta,
    onImpressionChangePlanCta,
}) => {
    const changePlanCtaColor = useMemo(() => (isBlackPlan ? "primary_One_Blck" : "swiggy_One"), [isBlackPlan]);
    const { navigateToDeeplinkGenericHelper, addSuperToCart } = handlers;

    const appStorageKey = COMPARISON_HALFCARD_STORAGE_KEY;
    const payload = {
        addSuperToCart,
        maxPollingCount: MAX_POLLING_COUNT,
        appStorageKey,
        planInCart,
    };
    const { startPollingAction } = usePolling(payload);

    useEffectOnce(() => onImpressionChangePlanCta());

    const openPlanComaprisonHalfcard = useCallback(() => {
        onClickChangePlanCta();

        startPollingAction();

        const formattedLink: string = attachQueryParams(link, { planId, planInCart, appStorageKey });
        navigateToDeeplinkGenericHelper(formattedLink);
    }, [
        appStorageKey,
        link,
        navigateToDeeplinkGenericHelper,
        onClickChangePlanCta,
        planId,
        planInCart,
        startPollingAction,
    ]);

    return (
        <ComparisonHalfCardCta
            data-testid={CART_UPSELL_TEST_IDS.CHANGE_PLAN_CTA}
            onClick={openPlanComaprisonHalfcard}
            underlineColor={changePlanCtaColor}
        >
            <Text
                variant="V2.overline.neutral.medium"
                fontWeight={600}
                color={changePlanCtaColor}
                dangerouslySetInnerHTML={{ __html: text }}
            />
        </ComparisonHalfCardCta>
    );
};

export default memo(ChangePlanCta);
